import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function TermsAndConditions() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div id='TermsAndConditions' className="container py-5" style={{marginTop: '7rem'}}>
      <div className="mb-4" data-aos="fade-up">
        <h1 className="display-5 fw-bold">Terms and Conditions</h1>
        <h2 className="h5 fw-semibold">Rayan Info Solutions</h2>
        <p className="text-muted">Effective as of: April 01, 2024</p>
      </div>

      <p className="mb-3" data-aos="fade-up">
        Welcome to Rayan Info Solutions. We specialize in a wide range of software development and IT services.
        By accessing or using any part of our digital platforms, you acknowledge and agree to the following
        Terms and Conditions ("Terms").
      </p>
      <p className="mb-4" data-aos="fade-up">
        Please read them carefully, as they govern your use of our offerings.
      </p>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">1. Contact & Communication</h3>
        <p>
          For any inquiries, suggestions, or concerns related to these Terms or our services, please reach out
          to us directly at <a href="mailto:rayaninfosolutions@gmail.com">rayaninfosolutions@gmail.com</a>.
          We value clear communication and aim to respond promptly.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">2. Service Disclaimer & Limitation of Liability</h3>
        <p>
          All services provided by Rayan Info Solutions are offered on an "as available" and "as is" basis.
          We do not guarantee that our content, functionality, or tools will be uninterrupted, fully accurate,
          or error-free at all times.
        </p>
        <p>
          Rayan Info Solutions will not be held accountable for any losses—whether direct, indirect, incidental,
          or consequential—that may arise from the use or inability to use our services.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">3. Usage Expectations</h3>
        <p>
          Users are expected to engage with our services in a lawful, ethical, and respectful manner.
          Any behavior or activity that breaches legal standards or disrupts our systems or other users'
          experiences may result in restriction or termination of access without notice.
        </p>
        <p>
          You may not:
            - Modify, reverse engineer, or decompile the Software.
            - Distribute or sublicense the Software to any third party.
        </p>
        <p>
          We reserve the full right to take necessary action if any misuse, abuse, or unauthorized access is detected.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">4. Account Responsibilities & Consent</h3>
        <p>
          It is your sole responsibility to ensure that your login credentials remain secure.
          You must not impersonate others or attempt to access any service or data that does not belong to you.
        </p>
        <p>
          By submitting any contact details through our website forms, you authorize us—or our authorized third-party
          service providers—to contact you via call or SMS for promotional or service-related purposes.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">5. Policy Updates</h3>
        <p>
          These Terms are subject to change at our discretion. Updates may be applied without prior individual notice.
          You are encouraged to revisit this page periodically to stay informed about any modifications.
        </p>
        <p>
          Continued use of our services following any update constitutes your acceptance of the revised Terms.
        </p>
      </div>

      <div className="mt-5" data-aos="fade-up">
        <p>We appreciate your interest in Rayan Info Solutions.</p>
        <p>
          Our goal is to provide exceptional software solutions tailored to modern needs.
          For additional support or clarification, feel free to get in touch.
        </p>
        <p className="fw-semibold mt-4">
          Warm regards,<br />
          The Rayan Info Solutions Team<br />
          📧 <a href="mailto:rayaninfosolutions@gmail.com">rayaninfosolutions@gmail.com</a>
        </p>
      </div>
    </div>
  );
}
